module.exports = __webpack_public_path__ + "img/details.36982930.png";